<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="806" height="233" viewBox="0 0 806 233" fill="none" style="margin: 0 auto">
    <g clip-path="url(#clip0_991_4007)">
      <rect width="806" height="233" fill="white"/>
      <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="13"
            font-weight="500" letter-spacing="0.01em"><tspan x="321.16" y="196.22">Сохранность контингента</tspan></text>
      <text fill="#00599B" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="13"
            font-weight="500" letter-spacing="0.01em"><tspan x="576.616" y="196.22">Потребность в приеме</tspan></text>
      <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#263238" xml:space="preserve"
            style="white-space: pre" font-family="Raleway" font-size="47" letter-spacing="0.01em"><tspan x="404" y="164.18">{{ $scripts.TableJs.checkValueWithNullAndReturnND(Number.isNaN(getMcData.kq * 100) ? (getMcData.kq === 'н.д.' ? 'н.д.': 'x'): getMcData.kq * 100, 1, 'float', true,  'н.д.', '', (v) => v + '%') }}</tspan></text>
      <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#00599B" xml:space="preserve"
            style="white-space: pre" font-family="Raleway" font-size="47" font-weight="bold" letter-spacing="0.01em"><tspan x="650" y="164.18">{{ getMcData.pp }}</tspan></text>
      <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="46.5581"
            letter-spacing="0.01em"><tspan x="268" y="159.765">:</tspan></text>
      <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="46.5581"
            letter-spacing="0.01em"><tspan x="514" y="159.765">=</tspan></text>
      <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="13"
            font-weight="500" letter-spacing="0.01em"><tspan x="44.3161" y="196.22">Потребность в подготовке кадров</tspan></text>
      <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#263238" xml:space="preserve"
            style="white-space: pre" font-family="Raleway" font-size="47" letter-spacing="0.01em"><tspan x="154" y="164.18">{{ getMcData.pv }}</tspan></text>
      <line x1="30" y1="101.5" x2="775" y2="101.5" stroke="#CFD8DC"/>
      <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="16"
            letter-spacing="0.01em"><tspan x="30" y="77.24"><tspan x="31" y="77.24" font-weight="600">{{ getMcData.sprRegionName }}</tspan>, {{getMcData.sprKcpGroupSprUslName }}: {{ getMcData.sprKcpGroupId }} {{ getMcData.sprKcpGroupName }}.</tspan></text>
      <text fill="#00599B" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="22"
            letter-spacing="0.01em"><tspan x="30" y="43.68">Планирование потребности в приеме
</tspan></text>
    </g>
    <defs>
      <clipPath id="clip0_991_4007">
        <rect width="806" height="233" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</template>

<script>
import request from "@/services/request";
import {svgPropsMapper} from "@/mixins/svgPropsMapper";

export default {
  name: "McSvg",
  mixins: [svgPropsMapper],
  props: {
    kcpGroupId: null,
    regionId: null,
  },
  data() {
    return {
      getMcData: {
        id: 0,
        sprKcpGroupId: "string",
        sprKcpGroupName: "string",
        sprKcpGroupSprUslName: "string",
        sprRegionId: "string",
        sprRegionName: "string",
        sprRegionNameGenitive: "string",
        pv: 0,
        kq: 0,
        pp: 0
      },
    }
  },
  async created() {
    await this.getMcSvg();
  },
  methods: {
    async getMcSvg() {
      try {
        const res = await request({
          endpoint: `/api/information/getMc?kcpGroupId=${this.kcpGroupId}${this.regionId ? '&regionId='+this.regionId : ''}`,
          method: 'get',
        });
        if (res.status === 200 ) {
          console.log('getMcSvg успех');
          if (res.data) {
            this.mapServerData(res.data);
          }else
            this.mapServerData();
        }
        this.changeDefaultValues()
      } catch (e) {
        console.log(e);
      }
    },
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Raleway:wght@400;500;700');

text {
  font-feature-settings: 'pnum' on, 'lnum' on;
}
</style>